import React, { useContext, useEffect, useState } from "react";
import Button_v2 from "./Button_v2";
import { Col, Row , Form, Select, Progress } from "antd";
import SubordersGridLIst from "./SubordersGridLIst";
import { ScreenKeys } from "../../containers/constants";
import { UserContext } from "../../context/UserContext";
import ModalComponent from "./Modal_v2";
import CloseIcon from "../../../assets/images/IconClose.svg";
import { fetchConsolidatedMawbs, mawbConnections } from "../../api/OrdersApi";
import { use } from "react";
import { OrgContext } from "../../context/OrgContext";
import { alertMessage } from "../../common/Common";
import ErrorComponent from "../../components/common/ErrorComponent";
import { is } from "core-js/core/object";
import SuborderModal from "./SuborderModal";


function SubOrdersView(props) {
  const {orderResponse,consolidatedData,doRefreshDetails,setActiveKey} = props
  const userContext = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [currentGridRef, setCurrentGridRef] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [consolidateLoading, setConsolidateLoading] = useState(false);
  const [allStatus, setAllStatus] = useState([]);
  const [warningMessages, setWarningMessages] = useState([]);
  const orgData = useContext(OrgContext);
  const [formValues, setFormValues] = useState({
    order_numbers: [],
    hawb_numbers: [],

  })

  const handleColumnVisibilityChange = (event) => {
    if (!event.visible) {
      const columnName = event.column.getColDef().headerName;
      this.setColDefCheckbox(columnName);
    }
  };

   const handleSelectChange = (value, fieldName) => {
    setFormValues((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
  
  };

  
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);


const handleSave = (record, text) => {
  const orderLInkData = record.order_numbers ? record.order_numbers : [];
  const hawbLInkData = record.hawb_numbers ? record.hawb_numbers : [];

  const orderDelinkData = consolidatedData
    .filter((item) => item.customer_order_number)
    .map((item) => item.customer_order_number)
    .includes(record.customer_order_number)
    ? [record.customer_order_number]
    : [];

  const hawbDelinkData = consolidatedData
    .filter((item) => item.Hawb)
    .map((item) => item.Hawb)
    .includes(record.Hawb)
    ? [record.Hawb]
    : [];

  if (hawbDelinkData.length === 1 && hawbDelinkData[0] === 'N/A') {
    hawbDelinkData.length = 0; // Makes it an empty array
  }

  const orderData = text === "delink" ? orderDelinkData : orderLInkData;
  const hawbData = text === "delink" ? hawbDelinkData : hawbLInkData;
  // Show the loader
  setIsLoading(true);

  const payload = {
    parent_order_id: orderResponse.id,
    order_numbers: orderData || [],
    account_id: orderResponse?.account?.account_id,
    hawb_numbers: hawbData || [],
    operation: text,
    org_id: _.get(orgData, "currentOrg.id", ""),
  };
  mawbConnections(payload)
    .then((res) => {
      if (res.success) {
        let messages = [];
        const warnings = res.data.warnings;

        if (Array.isArray(warnings)) {
          messages = warnings;
        } else if (
          Object.values(warnings).some(
            (array) => Array.isArray(array) && array.length > 0
          )
        ) {
          if (warnings.failed_hawb_numbers?.length > 0) {
            messages.push(
              `Failed HAWB Numbers: ${warnings.failed_hawb_numbers.join(", ")}`
            );
          }

          if (warnings.failed_order_numbers?.length > 0) {
            messages.push(
              `Failed Order Numbers: ${warnings.failed_order_numbers.join(", ")}`
            );
          }
        }

        setWarningMessages(messages);

        if (messages.length === 0) {
          alertMessage(res.data.message, "success");
          doRefreshDetails();
          setIsModalOpen(false);
        }
      } else {
        alertMessage(res.errors, "error");
      }
    })
    .catch((err) => {
      const errorMessage = Array.isArray(err) ? err.join(', ') : 'An error occurred';
      alertMessage(errorMessage, "error");
    })
    .finally(() => {
      // Hide the loader
      setIsLoading(false);
      setIsModalOpen(false);
    });
};

  
  return (
    <>
      <Row className="header-container">
        <Col span={12}>
          <span className="header-text">MAWB #{consolidatedData[0]?.Mawb} Orders</span>
        </Col>
        <Col span={12}>
          <Row className="buttons-container">
            <Col>
            <Button_v2
                // type="primary"
                type="secondary"
                className="outline small-btn"
                  onClick={() => openModal()}
                text={"Link Existing Order"}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              />
              {/* {I18n.t("general.email")} 
               Link Existing Order */}
            </Col>
            <Col>
            {/* <Button_v2
                // type="primary"
                type="secondary"
                className="outline small-btn"
                //   onClick={() => this.showEmailModal()}
                text={"Create New Order"}
                style={{ display: "flex", alignItems: "center", gap: "8px" , marginLeft:"12px"}}
              /> */}
              {/* <CreateOrderButton
                          viewType="label"
                          typeOFOrder={orderDetails.label_code || "D"}
                          reqFrom="create"
                          handleTypeChange={handleTypeChange}
                          disabledCodes={disabledCodes}
                          showOptions={[
                            "",
                            "NEW",
                            "RECEIVED",
                            "VERIFIED",
                            "ON_HOLD",
                          ].includes(status)}
                        /> */}
            </Col>
          </Row>
        </Col>
      </Row>
      {isModalOpen && (
        <SuborderModal 
        isVisible={isModalOpen} 
        onClose={closeModal} 
        onSave={handleSave}
        consolidatedData={consolidatedData} 
        orderResponse={orderResponse} 
        orgData={orgData} 
        setIsLoading={setIsLoading}
        screenType={"subOrdersView"}/>
      )}
      {
        warningMessages.length > 0 &&
        <ErrorComponent
                errors={[`${warningMessages.join(', ')}`]}
            />
      }
      <Row> 
      <Col style={{ height: "70vh", width: "100%",paddingLeft:"16px",paddingRight:"16px" }}>

      <SubordersGridLIst
            // accountWeightUnits={ props.accountUnitContext.accountWeightUnits }
            tableName={ScreenKeys.SUBORDERS_LISTING}
            rawDataSource={consolidatedData}
          
            userContext={userContext}
            // organizationSettings={props.organizationSettings}
            // showRerrangeableModal={showRerrangeableModal}
            orgData={orgData}
            isLoading={isLoading}
            // displayConfiguration={dispSetting}
            handleEditClick={handleSave}
            // deleteClick={handleDelete}
            // cloneClick={cloneQuote}
            // validateQuoteClick={validateQuote}
            // closeModal={closeModal}
            // tableChange={(pagination, filter, sorter) =>
            //   onTableChange(pagination, filter, sorter)
            // }
            setCurrentGridRef={setCurrentGridRef}
            // // displayConfiguration={props.displayConfiguration}
            // renderExtraHeader={renderExtraHeader}
            handleColumnVisibilityChange={handleColumnVisibilityChange}
            // dispContext={props.dispContext}
            // navigateToAccount={navigateToAccount}
            // showQuoteDetails={showQuoteDetails}
            // refreshQuotes={debouncedFetchQuotes}
            // pagination={tablePagination}  
            // {...pagination}
            // showPagination={true}
            // getPageWiseData={getPageWiseData}
            // onPerPageChanged={onRecordChange}
            // genarateQuote={genarateQuote}
            // setQuoteViewId={setQuoteViewId}
            RowHeight={40}
          />
          </Col>
      </Row>
      
    </>
  );
}

export default SubOrdersView;
